export default {
  id: 120,
  title: 'Target #120 - Tank',
  url: 'https://cssbattle.dev/play/120',
  colors: ['#000000', '#54C144', '#C74E4E', '#FFFFFF'],
  solution:
    '<a a><a b><a c><a d><style>[a],[c]{left:60}[b],[c]{width:40}[c],[d]{height:10}body{background:#000;border:20px solid #54c144;margin:0}a{position:fixed}[a]{top:60;width:200;height:40;background:linear-gradient(90deg,#c74e4e 80px,#000 80px 120px,#c74e4e 120px);box-shadow:0 80px #c74e4e}[b]{top:60;right:60;height:180;background:#c74e4e}[c]{top:200;background:#54c144;color:#54c144;box-shadow:10px 15px,0 30px}[d]{top:215;left:140;width:10;background:#fff;box-shadow:-20px 0 #fff,-65px 0 0 5px #54c144}</style>',
}
